module.exports = __webpack_public_path__ + "static/media/sg11cr0.faeb3c74.png";